// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"02d1e144","404":"88ff86b4","457":"d1b29089","532":"0968ed0a","648":"c18154f2","738":"cfd54da2"}[chunkId] + ".chunk.js";
};